import { type ReactNode, useCallback, useMemo, useState } from 'react'

import type { DrillRequest } from '../lib/filterTxns'
import { DrillDownContext } from './DrillDownContext'
import { TxnDrillDown } from './TxnDrillDown'

export function DrillDownProvider({ children }: { children: ReactNode }) {
  const [request, setRequest] = useState<DrillRequest | null>(null)
  const close = useCallback(() => setRequest(null), [])
  const api = useMemo(() => ({ openDrillDown: setRequest }), [])
  return (
    <DrillDownContext.Provider value={api}>
      {children}
      {request ? <TxnDrillDown key={JSON.stringify(request)} request={request} onClose={close} /> : null}
    </DrillDownContext.Provider>
  )
}
